<template>
  <div
    class="nav-menu__overlay"
    @click.prevent="closeNavMenu">
    <nav class="nav-menu">
      <div class="nav-menu__header">
        <v-btn
          outline
          :disabled="!isAuthenticated"
          color="secondary"
          class="favorites-button"
          @click.stop="openFavoritesDrawer">
          <v-icon class="favorites-button__icon">
            {{ favoritesTotal > 0 ? 'star' : 'star_border' }}
          </v-icon>
          <span class="favorites-button__label">
            favorites
          </span>
          <span class="favorites-button__quantity">
            {{ favoritesTotal }}
          </span>
        </v-btn>
        <v-btn
          :to="{ name: 'cart' }"
          outline
          color="secondary"
          class="cart-button">
          <v-icon class="cart-button__icon">
            shopping_cart
          </v-icon>
          <span class="cart-button__label">
            cart
          </span>
          <span class="cart-button__quantity">
            {{ cartTotal }}
          </span>
        </v-btn>
      </div>

      <router-link
        :to="{ name: 'home' }"
        class="nav-item">
        home
      </router-link>
      <router-link
        :to="{ name: 'hat-catalog' }"
        class="nav-item">
        hats
      </router-link>

      <div class="nav-row">
        <div class="nav-row__header">
          <hr class="nav-row__divider">
          <span class="nav-row__header-text">patches</span>
          <hr class="nav-row__divider">
        </div>
        <router-link
          :to="{ name: 'patch-catalog' }"
          class="nav-row-item">
          permanent catalog
        </router-link>
        <router-link
          :to="{ name: 'patch-submissions' }"
          class="nav-row-item beta">
          community submissions
        </router-link>
      </div>

      <router-link
        :to="{ name: 'custom-start' }"
        class="nav-item">
        create your own
      </router-link>
      <router-link
        :to="{ name: 'submit-start' }"
        class="nav-item beta">
        submit design
      </router-link>

      <div class="nav-row nav-row--no-border">
        <div class="nav-row__header">
          <hr class="nav-row__divider">
        </div>
        <router-link
          :to="{ name: 'articles' }"
          class="nav-row-item">
          news
        </router-link>
      </div>

      <!-- IF LOGGED IN -->
      <div
        v-if="isAuthenticated"
        class="nav-menu__account-row">
        <v-btn
          :to="{
            name: 'profile'
          }"
          outline
          color="secondary"
          class="account">
          <v-icon>account_circle</v-icon>
          account
        </v-btn>
        <v-btn
          :to="{
            name: 'logout'
          }"
          flat
          color="secondary"
          class="logout">
          <v-icon>exit_to_app</v-icon>
          log out
        </v-btn>
      </div>
      <!-- IF NOT LOGGED IN -->
      <div
        v-if="!isAuthenticated"
        class="nav-menu__account-row">
        <v-btn
          :to="{
            name: 'create-account'
          }"
          flat
          color="secondary"
          class="create-account">
          create account
        </v-btn>
        <v-btn
          :to="{
            name: 'login'
          }"
          outline
          color="secondary"
          class="login">
          <v-icon>exit_to_app</v-icon>
          log in
        </v-btn>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'NavMenu',
  computed: {
    navMenu() {
      return this.$store.state.app.navMenu;
    },
    isAuthenticated() {
      return this.$store.getters['auth/isAuthenticated'];
    },
    favoritesTotal() {
      return this.$store.getters['user/favoritesTotal'];
    },
    cartTotal() {
      return this.$store.getters['cart/totalItems'];
    },
  },
  methods: {
    openFavoritesDrawer() {
      this.$store.dispatch('app/openMenu', 'favoritesDrawer');
    },
    closeNavMenu() {
      this.$store.dispatch('app/closeAllDrawers');
    },
  },
};
</script>

<style lang="stylus" scoped>
@require('../stylus/base')

.nav-menu__overlay
  position: fixed
  top: 0
  left: 0
  width: 100vw
  height: 100vh

  display: flex
  flex-flow: column nowrap
  align-items: center
  justify-content: center

  z-index: 7

  background-color: $primary


.nav-menu
  display: flex
  flex-flow: column nowrap
  align-items: stretch
  justify-content: space-between
  width: 24rem
  max-width: 90%
  &__header
    display: flex
    align-items: center
    justify-content: space-between
    border-bottom: 1px solid $secondary
  &__account-row
    display: flex
    align-items: center
    justify-content: space-between
    border-top: 1px solid $secondary
    border-bottom: 1px solid $secondary
  &__footer
    display: flex
    align-items: center
    justify-content: center

.favorites-button,
.cart-button
  display: flex
  flex: 1 1 0
  flex-flow: row nowrap
  align-items: center
  &__quantity
    padding-left: $base-padding

.favorites-button
  margin-left: 0
  margin-right: 0
.cart-button
  margin-right: 0

.nav-row
  display: flex
  flex-flow: row wrap
  align-items: flex-start
  justify-content: center
  border-bottom: 1px solid $secondary
  &--no-border
    border-bottom: none
  &__header
    display: flex
    flex: 1 1 100%
    align-items: center
    justify-content: space-between
    text-transform: uppercase
    color: $secondary
    &-text
      padding: 0 $base-padding
      font-size: $font-size--small
      font-weight: $base-header-font-weight
  &__divider
    width: 100%
    height: 1px
    background-color: $secondary
    border: 0


.nav-item,
.nav-row-item
  position: relative
  padding: $base-padding*.5 $base-padding
  font-size: 2.5rem
  font-weight: $base-header-font-weight
  text-align: center
  text-transform: uppercase
  text-decoration: none
  color: $secondary
  border-radius: $base-border-radius
  transition: $base-transition
  &::before
    content: ''
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    color: inherit
    opacity: .12
    transition: $base-transition
  &:hover::before
    background-color: $secondary
  @media screen and (max-width: 24rem)
    font-size: 1.75rem

.nav-row-item
  flex: 1 1 0
  max-width: 12rem
  font-size: 1.5rem
  @media screen and (max-width: 24rem)
    font-size: 1rem

.account,
.create-account
  margin-left: 0
.logout,
.login
  margin-right: 0

.coming-soon
  position: relative
  opacity: .25
  overflow: hidden
  &::before
    opacity: 0
  &::after
    content: 'coming soon'
    position: absolute
    top: 1.5rem
    right: -1.75rem
    padding: 0 $base-padding*3
    font-size: .75rem
    color: $primary
    background-color: $secondary
    opacity: 1
    transition: $base-transition
    z-index: 1
    transform: rotate(45deg)

.beta
  position: relative
  overflow: hidden
  &::after
    content: 'beta'
    position: absolute
    top: .5rem
    right: -1.5rem
    padding: 0 $base-padding*3
    font-size: .75rem
    color: $primary
    background-color: $secondary
    opacity: 1
    transition: $base-transition
    z-index: 1
    transform: rotate(45deg)
</style>
